import { useMutation } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

export const useDeleteUser = () => {
  return useMutation({
    mutationFn: async (payload: { id: string }) => {
      const res = await client.admin.user[":id"].$delete({
        param: {
          id: payload.id,
        },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "users"] });
    },
  });
};
